"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.validateDrawingParameterSettings = exports.IDrawingParameterJsonSchema = void 0;
const zod_1 = require("zod");
// #endregion Interfaces (2)
// #region Variables (2)
const optionalBoolean = zod_1.z.preprocess((val) => {
    if (val === "true")
        return true;
    if (val === "false")
        return false;
    if (val === null)
        return undefined;
    return val;
}, zod_1.z.boolean().optional());
exports.IDrawingParameterJsonSchema = zod_1.z.object({
    geometry: zod_1.z
        .object({
        mode: zod_1.z.enum(["points", "lines"]),
        minPoints: zod_1.z.number().nullable().optional(),
        maxPoints: zod_1.z.number().nullable().optional(),
        strictMinMaxPoints: optionalBoolean,
        close: optionalBoolean,
        autoClose: optionalBoolean,
    })
        .nullable()
        .optional(),
    restrictions: zod_1.z.array(zod_1.z.any()).nullable().optional(),
    general: zod_1.z
        .object({
        prompt: zod_1.z
            .object({
            inactiveTitle: zod_1.z.string().nullable().optional(),
            activeTitle: zod_1.z.string().nullable().optional(),
            activeText: zod_1.z.string().nullable().optional(),
        })
            .nullable()
            .optional(),
        options: zod_1.z
            .object({
            showDistanceLabels: optionalBoolean,
            showPointLabels: optionalBoolean,
            snapToVertices: optionalBoolean,
            snapToEdges: optionalBoolean,
            snapToFaces: optionalBoolean,
        })
            .nullable()
            .optional(),
    })
        .nullable()
        .optional(),
});
const validateDrawingParameterSettings = (param) => {
    return exports.IDrawingParameterJsonSchema.safeParse(param);
};
exports.validateDrawingParameterSettings = validateDrawingParameterSettings;
// #endregion Variables (2)
//# sourceMappingURL=IDrawingParametersSettings.js.map